$(document).ready(function(){
    $(document).on('click', '.add_extra_prd_btn', function(){
        $(this).next().addClass('open');
    });
    $(document).on('click', '.add_extra_product_popup_inner span.close_btn', function(){
        $('.add_extra_product_popup_main').removeClass('open');
    });
    $(document).on('click', '.add_extra_product_popup .option_name', function(){
        setTimeout(() => {
            $(this).next().addClass('open');
        }, 500);
        
    });
    $(document).on("click", function (e) {
    if ($(e.target).closest(".option_value_box").length === 0) {
        $('.option_value_box').removeClass('open');
    }
    });
    $(document).on('click', '.option_value_box .option_value', function(){
       $(this).closest('.option_box').find('.option_value.active').removeClass('active');
       $(this).addClass('active');
       var getValue = $(this).attr('value');
       $(this).closest('.option_box').find('.option_name').addClass('selected').text(getValue).removeClass('borderred');;
       $(this).closest('.option_value_box').removeClass('open');

       let allSelected = true;
        var pleaseSelect;
        let selectedOptions = [];
        var finalselectedid;

        var finalSelect = $(this).closest('.add_extra_product_single').find('.add_extra_prd_btn');
        var singlePopup = $(this).closest('.add_extra_product_popup_main');
        var pricebox = $(this).closest('.add_extra_product_popup_main').find('.price_extraprdadd');
        $(this).closest('.add_extra_product_popup_main').find('.option_name').each(function () {
            if (!$(this).hasClass('selected')) {
                allSelected = false;
                var thisItem = $(this).text();
                $(this).addClass('borderred');
                 pleaseSelect = `Please select ${thisItem}`;
                return false; // stop loop early if any is not selected
            }
        });

        $(this).closest('.add_extra_product_popup_main').find('.option_name.selected').each(function(){
            selectedOptions.push($(this).text().trim());
        //    alert(selectedoption);
        });

        let finalResult = selectedOptions.join(" / ");

        

        if (allSelected) {

            $(this).closest('.add_extra_product_popup_inner').find('.single_variant').each(function(){
                var alltitle = $(this).attr('varianttitle');
                var allvarId = $(this).attr('variantid');
                var price = $(this).attr('variantprice');
                var ComPrice = $(this).attr('variantComPrice');
                if(alltitle == finalResult){
                   console.log(alltitle);
                   console.log(allvarId);
                   finalselectedid = allvarId;
                   pricebox.text(price);
                   pricebox.attr('prdVarPrice', price);
                   pricebox.attr('variantComPrice', ComPrice)
                }
                
            });
            
            //alert(finalResult);
            //finalSelect.text(finalResult).addClass('selected_variant').attr('variantId', finalselectedid);
             
        } else {
            // alert(pleaseSelect);
        }
    });
    $(document).on('click', '.add_extra_product_popup_main .selection_btn_material', function () {
        $('.option_name').removeClass('borderred');
        let allSelected = true;
        var pleaseSelect;
        let selectedOptions = [];
        var finalselectedid;
        var finalSelectPrice = $(this).closest('.add_extra_product_popup_inner').find('.price_extraprdadd').attr('prdvarprice');
        finalSelectPrice = finalSelectPrice.replace('£', '').replace(',', '');
        var finalSelectComPrice = $(this).closest('.add_extra_product_popup_inner').find('.price_extraprdadd').attr('variantcomprice');
        if(finalSelectComPrice){
           finalSelectComPrice = finalSelectComPrice.replace('£', '').replace(',', '');
        }
        
        // alert(finalSelectPrice);
        // alert(finalSelectComPrice);

        var finalSelect = $(this).closest('.add_extra_product_single').find('.add_extra_prd_btn');
        var singlePopup = $(this).closest('.add_extra_product_popup_main');
        var pricebox = $(this).closest('.add_extra_product_popup_main').find('.price_extraprdadd');
        $(this).closest('.add_extra_product_popup_main').find('.option_name').each(function () {
            if (!$(this).hasClass('selected')) {
                allSelected = false;
                var thisItem = $(this).text();
                $(this).addClass('borderred');
                 pleaseSelect = `Please select ${thisItem}`;
                return false; // stop loop early if any is not selected
            }
        });

        $(this).closest('.add_extra_product_popup_main').find('.option_name.selected').each(function(){
            selectedOptions.push($(this).text().trim());
        //    alert(selectedoption);
        });

        let finalResult = selectedOptions.join(" / ");

        

        if (allSelected) {

            $(this).closest('.add_extra_product_popup_inner').find('.single_variant').each(function(){
                var alltitle = $(this).attr('varianttitle');
                var allvarId = $(this).attr('variantid');
                var price = $(this).attr('variantprice');
                var ComPrice = $(this).attr('variantComPrice');
                if(alltitle == finalResult){
                   console.log(alltitle);
                   console.log(allvarId);
                   finalselectedid = allvarId;
                   pricebox.text(price);
                   pricebox.attr('prdVarPrice', price);
                   pricebox.attr('variantComPrice', ComPrice)
                }
                
            });
            
            //alert(finalResult);
            finalSelect.text(finalResult).addClass('selected_variant').attr('variantId', finalselectedid).attr('prdvarprice', finalSelectPrice).attr('prdvarcomprice', finalSelectComPrice);
            
               singlePopup.removeClass('open');
            
             
        } else {
            // alert(pleaseSelect);
        }
    });

    // $(document).on('click', '#addToCart', function(){
    //        var items = [];

    //         $('.selected_variant').each(function(){
    //             var id = $(this).attr('variantid');
    //             if(id){
    //             items.push({ id: Number(id), quantity: 1 });
    //             }
    //         });

    //         if(items.length){
    //             $.post('/cart/add.js', { items: items }, function(){
    //             // alert('All products added to cart!');
    //             }, 'json');
    //         }
    // });
    

    $(document).on('mouseup', function(e) {
    // if the target of the click isn't the container
    // nor a descendant of the container
        if (!$('.add_extra_product_popup_inner').is(e.target) && 
            $('.add_extra_product_popup_inner').has(e.target).length === 0) {
            $('.add_extra_product_popup_main').removeClass('open');
        }
    });

    setInterval(() => {
        extra_prd_length = $('.add_extra_products_box .selected_variant');
        //console.log(extra_prd_length.length);
        if(extra_prd_length.length>0){

            var main_prd_price = $('#productPrice .money').text();
            main_prd_price = parseFloat(main_prd_price.replace('£', '').replace(',', '')) || 0;
            //$('#productPrice .money').text(main_prd_price);
            //console.log(main_prd_price);
            var main_prd_compare_price = $('#comparePrice .money').text();
            main_prd_compare_price = parseFloat(main_prd_compare_price.replace('£', '').replace(',', '')) || 0;
            //$('#comparePrice .money').text(main_prd_compare_price);
            //console.log(main_prd_compare_price);

            var ExtraVariantsPriceAll = 0;
            var ExtraVariantsComPriceAll = 0;
            $('.add_extra_products_box .selected_variant').each(function() {
                var ExtraVariantsPrice = parseFloat($(this).attr('prdvarprice')) || 0;
                var ExtraVariantsComPrice = parseFloat($(this).attr('prdvarcomprice')) || 0;
                ExtraVariantsPriceAll += ExtraVariantsPrice;
                ExtraVariantsComPriceAll += ExtraVariantsComPrice;
            });

            console.log("Total Extra Variants Price:", ExtraVariantsPriceAll);
            console.log("Total Extra Variants compare Price:", ExtraVariantsComPriceAll);
            var totalPrice = ExtraVariantsPriceAll + main_prd_price;
            var formattedPrice = '£' + totalPrice.toLocaleString('en-GB', { minimumFractionDigits: 2 });
            $('.total_price_box .total_price').text(formattedPrice);
            var totalComPrice = ExtraVariantsComPriceAll + main_prd_compare_price;
            var formattedComPrice = '£' + totalComPrice.toLocaleString('en-GB', { minimumFractionDigits: 2 });
            $('.total_price_box .total_compare_price').text(formattedComPrice);
            $('.pro-price_main').hide();
            $('.total_price_box').show();
 
        }
        
    }, 2000); 
    

// EXTRA PRODUCT COLOR START   

// var exrtaPrdMatrialLengh = $('.add_extra_product_popup_inner .option_box[option_name="Material"]').length;
// alert(exrtaPrdMatrialLengh);
  
var chooseExtraColorClone = $('.choose_color_extra_prd').clone();

$('.add_extra_product_popup_inner .option_box[option_name="Material"]').each(function() {
    $(this).after(chooseExtraColorClone.clone());
});

$(document).on('click', '.option_name_color', function(){
    $(this).next().addClass('open');
});

$(document).on('click', '.selection_btn_color__exrta_prd', function(){
    var colorCod = $('.add_extra_product_popup_main.open .swatch_new_custom_extra_prd.active').attr('value');
    $(this).closest('.color_variant_22_extra_prd_outer').removeClass('open');
    $('.add_extra_product_popup_main.open .option_name_color').attr('selected_color', colorCod);
    $('.add_extra_product_popup_main.open .color_variant_22_extra_prd_inner').removeClass('select_color');
    $('.add_extra_product_popup_main.open .swatch_new_custom_extra_prd.active').removeClass('active');
    $(this).closest('.add_extra_product_single').find('.add_extra_prd_btn').attr('colorcod', colorCod);
});

$(document).on('click', 'span.close_btn_color', function(){
    $(this).closest('.color_variant_22_extra_prd_outer').removeClass('open');
    $('.add_extra_product_popup_main.open .color_variant_22_extra_prd_inner').removeClass('select_color');
});

setInterval(()=>{
   var selectedMaterialVal = $('.add_extra_product_popup_main.open .option_box[option_name="Material"] .option_value_box .option_value.active').attr('value');
//    alert(selectedMaterialVal);
   $('div[data_title_swatch_extra_prd]').each(function(){
     var currentDataTitlte = $(this).attr('data_title_swatch_extra_prd');
     if(selectedMaterialVal == currentDataTitlte){
        $(this).addClass('current_color_swatch');
     }else {
        $(this).removeClass('current_color_swatch');
     }
   });

//    var IsMaterialSelected = false;
   var checkMaterialSelectClass = $('.add_extra_product_popup_main.open .option_box[option_name="Material"] .option_name');

    if (checkMaterialSelectClass.hasClass('selected')) {
        $('.add_extra_product_popup_main.open .choose_color_extra_prd').addClass('open');
        var selectedColorEl = $('.add_extra_product_popup_main.open .option_name_color');
        var selectedColor = selectedColorEl.attr('selected_color');
        if(selectedColor == ''){
           $('.add_extra_product_popup_main.open .selection_btn_material').addClass('not_click');
           selectedColorEl.addClass('borderred').text('Colour');
           
            
        }else {
           $('.add_extra_product_popup_main.open .selection_btn_material').removeClass('not_click'); 
           selectedColorEl.removeClass('borderred').text(selectedColor);
        }
        
    } else {
        $('.add_extra_product_popup_main.open .choose_color_extra_prd').removeClass('open');
        
    }

},1000);

$(document).on('click', '.add_extra_product_popup_main.open .swatch_new_custom_extra_prd', function(){
    $('.add_extra_product_popup_main.open .swatch_new_custom_extra_prd').removeClass('active');
    $(this).addClass('active');
    var colorCod = $(this).attr('value');
    $('.add_extra_product_popup_main.open .color_variant_22_extra_prd_inner').addClass('select_color');
    var Img = $(this).find('.swatch_image').attr('src');
    $('.add_extra_product_popup_main.open .variant_color_custom_confirm_selection_exrta_prd .selected_image_color_exrta_prd').attr('src', Img);
    $('.add_extra_product_popup_main.open .variant_color_custom_confirm_selection_exrta_prd .selected_text_color_exrta_prd').text(colorCod);
    // $('.add_extra_product_popup_main.open .option_name_color').attr('selected_color', colorCod);

})


$(document).on('click', '.add_extra_product_popup_main.open .option_box[option_name="Material"] .option_value_box .option_value', function(){
    $('.add_extra_product_popup_main.open .option_name_color').attr('selected_color', '');
    var mainEtraPrdEl = $(this).closest('.add_extra_product_single').find('.add_extra_prd_btn');
           var mainEtraPrdElCurrText = mainEtraPrdEl.attr('currentText');
           mainEtraPrdEl.text(mainEtraPrdElCurrText).removeClass('selected_variant');
})
// EXTRA PRODUCT COLOR END 

});